import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

import Modal from "react-modal";

import CancelIcon from "../../assets/cancel_icon.svg";
import BidSuccess from "../../assets/bid_success.svg";

const HeaderSpan  = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
`

const ActionButtonDiv = styled.div`
  width: 398px;
  height: 44px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  cursor: pointer;
`

const ActionButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #000000;
`

const InfoTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;

  color: rgba(255, 255, 255, 0.45);
`
export default function ShowSocialSuccessModalComponent(props:any){

    let modalWidth = "446px";
    let modalHeight = "299px";    
    
    return (
        <Modal
	    isOpen={props.isOpen}
	    style={{
		content: {
		    background: "#0F0F0F",
		    width: modalWidth,
		    height: modalHeight,
		    marginLeft: "auto",
		    marginRight: "auto",
		    marginTop: "auto",
		    marginBottom: "auto",
		    border:"none",
	    }}}
	>
            <div style={{
	        display: 'flex',
	        flexDirection: 'column',
	        position: 'relative',
	        alignItems: 'center'}}>
                <img onClick={()=>{props.handleModalCloseEvent()}}
		     src={CancelIcon}
		     style={{
		         position: "absolute", opacity: 0.4,
		         height: 14, width:14,
		         right:10, cursor:"pointer",
		         zIndex:10
		     }}
	        />
                <div>
                    <img src={BidSuccess} style={{
                        width:42, height:42,
                        marginTop:34}} />
                </div>
                <div>
                    <HeaderSpan style={{marginTop:24}}>
                        Perk Info Submitted
                    </HeaderSpan>
                </div>
                <InfoTextSpan style={{marginTop:16}}>
                    Soon, creator's management will<br/>
                    reach out to you in order<br/>
                    to actually get em executed
                </InfoTextSpan>
                <ActionButtonDiv onClick={
                ()=>{props.handleModalCloseEvent()}}>
                    <ActionButtonTextSpan>
                        GOTCHA, THANKS
                    </ActionButtonTextSpan>

                </ActionButtonDiv>
            </div>
        </Modal>
    );
}
